export default __webpack_public_path__ + "static/media/ic_cost.536eeb33.svg";